<template>
  <div>
    <el-row :gutter="10" type="flex" justify="center">
      <el-col :lg="8" :md="12" :sm="24">
        <el-card class="login-form-container">
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            :hide-required-asterisk="true"
            @keyup.enter.native="onSubmit"
          >
            <h4>Đăng ký tài khoản</h4>
            <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
            <el-form-item label="Họ tên" prop="name">
              <el-input v-model="form.name" placeholder="Họ và tên"></el-input>
            </el-form-item>

            <el-form-item label="Email" prop="email">
              <el-input v-model="form.email" placeholder="Email"></el-input>
            </el-form-item>

            <el-form-item label="Mật khẩu" prop="password">
              <el-input v-model="form.password" type="password" placeholder="Mật khẩu"></el-input>
            </el-form-item>
            <el-form-item label="Nhập lại mật khẩu" prop="confirmPassword">
              <el-input v-model="form.confirmPassword" type="password" placeholder="Nhập lại mật khẩu"></el-input>
            </el-form-item>

            <el-form-item class="el-col-24" style="text-align: center">
              <el-button
                type="primary"
                size="medium"
                @click="onSubmit"
                :disabled="isRequesting"
                style="width: 100%; height: 44px"
                >Đăng ký
              </el-button>
            </el-form-item>
            <el-row justify="space-between" class="el-col-24">
              <router-link :to="Paths.LOGIN"> Đăng nhập </router-link>
              &nbsp;
              <router-link :to="Paths.REGISTRATION_RESEND_ACTIVATION"> Gửi lại email xác nhận? </router-link>
            </el-row>
            <br />
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { register } from '../services/authentication_service'
import { Paths } from '@/routes/paths.js'

const SUCCESS_AUTH_PAGE = '/manage/documents'

export default {
  name: 'Register',
  data() {
    let validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Nhập lại mật khẩu'))
      } else if (value !== this.form.password) {
        callback(new Error('Mật khẩu không khớp'))
      } else {
        callback()
      }
    }

    return {
      form: {
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
      },
      Paths,
      isRequesting: false,
      rules: {
        name: [{ required: true, message: 'Nhập tên đăng ký' }],
        email: [
          { required: true, message: 'Hãy nhập email đăng ký', trigger: 'change' },
          { type: 'email', message: 'Hãy nhập chính xác địa chỉ email', trigger: 'blur' },
        ],
        password: [
          { required: true, message: 'Hãy nhập mật khẩu ', trigger: 'change' },
          { min: 8, message: 'Mật khẩu tối thiểu 8 kí tự', trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true, message: 'Hãy nhập lại mật khẩu ', trigger: 'change' },
          { min: 8, message: 'Mật khẩu tối thiểu 8 kí tự', trigger: 'change' },
          { validator: validateConfirmPassword, trigger: 'change' },
        ],
      },
      errorMessage: null,
    }
  },
  methods: {
    onSubmit() {
      this.errorMessage = null
      let _this_ = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          _this_.isRequesting = true
          register(
            this.form.name,
            this.form.email,
            this.form.password,
            this.form.confirmPassword,
            this.onSuccess,
            this.onError,
            () => (_this_.isRequesting = false)
          )
        } else {
          return false
        }
      })
    },
    onSuccess() {
      this.$message({
        message: 'Đăng ký thành công, hệ thống sẽ gửi email xác nhận trong giây lát',
        type: 'success',
      })

      setTimeout(() => this.gotoLogin(), 1500)
    },
    onError(message) {
      this.errorMessage = message
      this.$message.error(message)
    },
  },
}
</script>

<style scoped>
.login-form-container {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 5px;
}

.error-message {
  margin-top: 2px;
  padding: 5px 5px 5px 10px;
  background-color: indianred;
  width: 100%;
  border-radius: 3px;
  color: white;
}
.el-form-item {
  margin-bottom: 15px;
}
</style>
